import { sm2 } from 'sm-crypto'

const C1C3C2 = 1

function normalizePublicKey(publicKey: string) {
  const normalized = publicKey.trim().replace(/\s+/g, '')
  return /^[0-9a-f]{128}$/i.test(normalized) ? `04${normalized}` : normalized
}

export function encryptWithSm2PublicKey(value: string, publicKey: string) {
  return sm2.doEncrypt(value, normalizePublicKey(publicKey), C1C3C2)
}
